<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Custom Sample Export'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '800px' }"
        (onHide)="close()"
>
    <!-- Explanation text -->
    <div class="text-sm text-gray-600 mb-4">
        Select one or more filters below to define which samples should be included in the export.
        The export will only contain samples that match all selected criteria. When a filter is empty, it will not
        filter out any samples for that criterion.
        You can clear filters individually or reset them all at once.
    </div>
    <div class="grid grid-cols-2 gap-4 my-3">
        <!-- Field of Use -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="fieldOfUseOptions"
                    [(ngModel)]="filters.fieldOfUse"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-field-of-use"
                    id="exp-field-of-use"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-field-of-use">Field of Use</label>
        </p-ifta-label>

        <!-- Sample Type -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleTypeOptions"
                    [(ngModel)]="filters.sampleType"
                    optionLabel="name"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-sample-type"
                    id="exp-sample-type"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-sample-type">Sample Type</label>
        </p-ifta-label>

        <!-- Sample State -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleStateOptions"
                    [(ngModel)]="filters.sampleState"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-sample-state"
                    id="exp-sample-state"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-sample-state">State</label>
        </p-ifta-label>

        <!-- Category -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleCategoryOptions"
                    [(ngModel)]="filters.sampleCategory"
                    optionLabel="name"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-category"
                    id="exp-category"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-category">Category</label>
        </p-ifta-label>

        <!-- Details -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleDetailOptions"
                    [(ngModel)]="filters.sampleDetail"
                    optionLabel="name"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-details"
                    id="exp-details"
                    [filter]="true"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-details">Details</label>
        </p-ifta-label>

        <!-- Format -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="sampleFormatOptions"
                    [(ngModel)]="filters.format"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-format"
                    id="exp-format"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-format">Format</label>
        </p-ifta-label>

        <!-- Brand -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="brandOptions"
                    [(ngModel)]="filters.brand"
                    optionLabel="label"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-brand"
                    id="exp-brand"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-brand">Brand</label>
        </p-ifta-label>

        <!-- Car Class -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="carClassOptions"
                    [(ngModel)]="filters.carClass"
                    optionLabel="label"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-car-class"
                    id="exp-car-class"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-car-class">Car Class</label>
        </p-ifta-label>

        <!-- Body Type -->
        <p-ifta-label>
            <p-multiSelect
                    [options]="bodyTypeOptions"
                    [(ngModel)]="filters.bodyType"
                    optionLabel="label"
                    optionValue="id"
                    class="w-full"
                    appendTo="body"
                    inputId="exp-body-type"
                    id="exp-body-type"
                    [showClear]="true"
            ></p-multiSelect>
            <label for="exp-body-type">Body Type</label>
        </p-ifta-label>

        <!-- Hide empty columns -->
        <div class="flex items-center justify-between pt-2 col-span-2">
            <label for="hide-empty" class="font-medium">Hide empty columns</label>
            <p-toggleswitch
                    id="hide-empty"
                    inputId="hide-empty"
                    [(ngModel)]="hideEmptyColumns"
            ></p-toggleswitch>
        </div>


        <!-- Active Filters -->
        <div class="mt-4 text-sm text-gray-600 italic">
            Active filters:
            {{ getActiveFiltersSummary() || 'None' }}
        </div>

    </div>

    <div class="flex justify-end gap-2 mt-6">
        <p-button label="Reset" icon="pi pi-filter-slash" (click)="reset()" severity="secondary"></p-button>
        <p-button label="Export" icon="pi pi-download" (click)="confirm()"></p-button>
    </div>
</p-dialog>
